import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const toolsStaticData = {
  menuTitle: MenuTitle.Tools
};
export const Route = createFileRoute('/_private-routes/tools')({
  staticData: toolsStaticData
});
